<template>
    <v-form v-model="form" ref="form_step_2">
        <v-row class=" mb-5">
            <v-col cols="12" style="min-height: 400px">
                <renters-simple-list class="mt-5"></renters-simple-list>
                <additional-information-input v-if="notes_in_advance"></additional-information-input>
                <h5 class="mt-15 font-weight-bold error--text text-break">
                    Please check any of the individual reservations above, if correct, push "continue" to move to the checkout page.
                </h5>
            </v-col>
        </v-row>
        <steps-navigation :error-messages-list="errorMessagesList"
                          :errors="v__getErrors()"
                          @step-next="stepNext"
                          @step-back="stepBack({validate:false,submit:false})">
        </steps-navigation>
    </v-form>
</template>

<script>
import AdditionalInformationInput from "../../../components/partials/AdditionalInformationInput";
import RentersSimpleList          from "../../../components/partials/RentersSimpleList";
import StepsNavigation            from "../../../components/partials/StepsNavigation";
import {mapActions, mapGetters}               from "vuex";
import StepperComponentMixin      from "../../../mixins/StepperComponentMixin";
import ValidatableComponent       from "../../../mixins/ValidatableComponent";
import step_2                     from "../validation/step_2";

export default {
    name      : "Step2",
    components: {AdditionalInformationInput, StepsNavigation, RentersSimpleList},
    mixins    : [StepperComponentMixin,ValidatableComponent],
    data      : () => ({
        form: false,
        errorMessagesList: [],
    }),
    methods   : {
        ...mapActions(['do_save_reservee', 'do_calculate_cost']),
        async stepSubmit() {
          if(this.$store.state.model.reservees.length!==0) {
            const reservee_result = await this.do_save_reservee();
            if(reservee_result.status && reservee_result.status===200) {
              await this.do_calculate_cost();
                if(!this.cost.free_checkout && this.do_not_show_price_on_checkout==0 && this.skip_checkout==0 && !(this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1)){
                  if(((this.prepay_payment || this.only_save_card_at_prepay) && window.location.href.includes('prepay')) || (this.only_save_card_at_advanced || this.advance_reservation_payment_checkout)){
                    if(!this.rechapcha_is_checked && this.$store.state.resources.config.google_recaptcha=="1" && this.$store.state.resources.config.google_recaptcha_site_key!=''){
                        this.$store.commit('set_disabled_status', true);
                    }
                  }
                }
                if(this.$store.state.model.reservation.group_link_id){
                    this.$store.commit('set_disabled_status', false);
                }
              return true;
            }else{
              this.errorMessagesList[0] = reservee_result.data.message;
            }
          }else{
            this.errorMessagesList[0] = "Please add a renter!";
          }
        }
    },
    computed  : {
        reservation() {
            return this.$store.state.model.reservation;
        },
        cost() {
            return this.$store.state.model.cost;
        },
        notes_in_advance(){
          return parseInt(this.$store.state.resources.config.notes_in_advance);
        },
        no_priceing_checkouts() {
            return this.$store.state.resources.config.no_priceing_checkouts;
        },
        prepay_payment(){
            return parseInt(this.$store.state.resources.config.prepay_payment);
        },
        only_save_card_at_prepay(){
            return parseInt(this.$store.state.resources.config.only_save_card_at_prepay);
        },
        only_save_card_at_advanced() {
            return parseInt(this.$store.state.resources.config.only_save_card_at_advanced);
        },
        advance_reservation_payment_checkout() {
            return parseInt(this.$store.state.resources.config.advance_reservation_payment_checkout);
        },
        ...mapGetters(['rechapcha_is_checked', 'do_not_show_price_on_checkout', 'skip_checkout'])

    },
    mounted() {
        const self = this;
        this.withValidation({
            getModel() {
                return self.$store.state.model;
            },
            rules : step_2,
            fields: {}
        })
    }
}
</script>

<style scoped>

</style>
